import { Box, CircularProgress, type SxProps, Typography } from '@mui/material'

export function InlineLoadingSpinner({
  text,
  sx
}: LoadingSpinnerProps & {
  sx?: SxProps
}) {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, ...sx }}
    >
      <CircularProgress size={24} sx={{ color: '#153CB7' }} />
      {text && (
        <Typography variant='body1' sx={{ color: '#1A1A1A' }}>
          {text}
        </Typography>
      )}
    </Box>
  )
}

interface LoadingSpinnerProps {
  text?: string
}

export default function LoadingSpinner({ text }: LoadingSpinnerProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'white'
      }}
    >
      <CircularProgress size={48} sx={{ color: '#153CB7' }} />
      {text && (
        <Typography variant='body1' sx={{ color: '#1A1A1A' }}>
          {text}
        </Typography>
      )}
    </Box>
  )
}
